export default __webpack_public_path__ + "src/images/partner/berlin-startup-stipendium.png";